import { useState } from "react";
import { Dropdown, Typography } from "antd";
import type { MenuProps } from "antd";
import { useMsal } from "@azure/msal-react";

const { Text } = Typography;

const getDisplayName = (name?: string, username?: string): string => {
  if (name && name.trim().length > 0) {
    return name;
  }

  return username ?? "";
};

const AuthStatus = () => {
  const { accounts, instance } = useMsal();
  const [isSigningOut, setIsSigningOut] = useState(false);

  if (!accounts.length) {
    return null;
  }

  const account = accounts[0];
  const displayName = getDisplayName(account?.name, account?.username);

  const handleLogout = async () => {
    setIsSigningOut(true);
    try {
      await instance.logoutPopup();
    } finally {
      setIsSigningOut(false);
    }
  };

  const menuItems: MenuProps["items"] = [
    {
      key: "signout",
      label: isSigningOut ? "Odhlasujem..." : "Odhlásiť sa",
      onClick: handleLogout,
      disabled: isSigningOut,
    },
  ];

  return (
    <div className="auth-status">
      <Dropdown menu={{ items: menuItems }} trigger={["click"]}>
        <Text ellipsis className="auth-status__name" style={{ cursor: "pointer" }}>
          {displayName}
        </Text>
      </Dropdown>
    </div>
  );
};

export default AuthStatus;
